import React, { useEffect } from "react";
import { motion } from "framer-motion";

export default function FounderMessage({ 
  accent = "#115e32",
  pageTitle = "Founder & Chairman Message | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  return (
    <div className="relative w-full min-h-screen bg-gradient-to-b from-[#B7EAFC] via-[#F0FCFF] to-[#F0FCFF]">
      {/* Hero Section with SVG */}
      <section className="relative overflow-hidden bg-gradient-to-r from-[#B7EAFC] via-[#D6F5FE] to-[#E6FAFE]">
        {/* SVG Decorative Background */}
        <div className="absolute inset-0 flex justify-center items-center opacity-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="650"
            height="650"
            viewBox="0 0 650 650"
            fill="none"
            className="animate-spin-slow"
          >
            <circle
              cx="325"
              cy="325"
              r="280"
              stroke="#d4af37"
              strokeWidth="3"
              strokeDasharray="12 12"
            />
            <circle
              cx="325"
              cy="325"
              r="180"
              stroke="#2563eb"
              strokeWidth="2"
              strokeDasharray="8 8"
            />
          </svg>
        </div>

        <div className="relative container mx-auto px-6 py-20 text-center">
          <motion.h1
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
            className="text-4xl md:text-6xl font-extrabold text-gray-800"
          >
            Message from the{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#2563eb]">
              Founder & Chairman
            </span>
          </motion.h1>
        </div>
      </section>

      {/* VC Message Section */}
      <section className="relative container mx-auto px-6 py-16 grid md:grid-cols-2 gap-12 items-center">
        {/* VC Picture */}
        <motion.div
          initial={{ x: -50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="flex justify-center"
        >
          <img
            src="/img/Mohammad-Osman.jpg" // replace with actual VC image path
            alt="Founder"
            className="w-80 h-96 object-cover rounded-2xl shadow-lg border-4 border-[#014864]"
          />
        </motion.div>

        {/* VC Message */}
        <motion.div
          initial={{ x: 50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="space-y-6 text-gray-700"
        >
          <h2 className="text-2xl md:text-3xl font-bold text-[#014864]">
            Mohammad Osman
          </h2>
          <p className="italic text-sm text-gray-500">
            Founder & Chairman<br />            
          </p>
          <p className="leading-relaxed">
			<strong>Welcome to the vibrant community of the University of Creative Technology Chittagong (UCTC)!</strong><br/><br/>
            As the founder, my vision for UCTC is rooted in providing an educational experience that is not only academically enriching but also practical and innovative. At UCTC, our distinguished faculty members, equipped with international degrees and a wealth of experience, are dedicated to cultivating a learning environment that fosters creativity and critical thinking. We believe in shaping graduates who are not just academically proficient but also well-prepared to face the challenges of the evolving global landscape.
          </p>
          <p className="leading-relaxed">
            I extend my heartfelt gratitude to the UCTC Trust and all our well-wishers whose unwavering support has been instrumental in the establishment of UCTC. Together, we are on a journey to build a university that stands as a beacon of global excellence.
          </p>
          <p className="leading-relaxed">
            As we move forward, we are already equipped with modern facilities, including fully air-conditioned classrooms, digital libraries, smartboards, and digital laboratories. Our vision extends further to establishing a permanent campus in Chattogram with state-of-the-art amenities, creating a conducive environment for learning and growth.

          </p>
          <p className="leading-relaxed">
            With the blessings of Allah (SWT), we are confident in achieving our goals and making UCTC a renowned institution that not only meets but exceeds global standards. Join us in this exciting journey where education meets innovation and excellence!".
          </p>
         
        </motion.div>
      </section>
    </div>
  );
}
